import FerryList from '@/controllers/ferry/ferry-list.js';

export default {
  extends: FerryList,
}
